<template>
  <b-container v-if="renderPage">
    <b-row class="mb-4 column-change">
      <b-col
        xl="8"
        lg="7"
        sm="12"
      >
        <info-card :data="data" />
        <address-card
          v-if="data.link.status === 1"
          :address="address"
        />
        <progress-bar-transaction
          v-if="showProgressBar"
          :data="data"
        />
        <time-line-transaction
          v-if="!showProgressBar"
          :data="data"
        />
        <controllers-buttons
          v-if="data.link.status == 11 || data.link.status == 5"
          type="payment-link"
          :data="data"
        />
      </b-col>
      <b-col
        v-if="data.link.status !== 2 && data.link.status !== 5 && data.link.status !== 11 && data.link.status !== 12"
        md="12"
        class="mb-1"
        lg="5"
        xl="4"
      >
        <Receipt
          :receipt-data="data"
          type="transaction"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BContainer,
  BCol,
  BRow,
} from 'bootstrap-vue'

import ControllersButtons from '@/layouts/components/DetailsTransaction/ControllersButtons.vue'
import InfoCard from '@/layouts/components/DetailsTransaction/InfoCard.vue'
import AddressCard from '@/layouts/components/DetailsTransaction/AddressCard.vue'
import ProgressBarTransaction from '@/layouts/components/DetailsTransaction/ProgressBarTransaction.vue'
import Receipt from '@/layouts/components/Receipt.vue'
import TimeLineTransaction from '@/layouts/components/DetailsTransaction/TimeLineTransaction.vue'

import { getTransaction } from '@/service/transaction/transaction'

import { callLoading } from '@/service/utilities/utilities'

export default {
  components: {
    BContainer,
    BCol,
    BRow,
    AddressCard,
    Receipt,
    ControllersButtons,
    InfoCard,
    ProgressBarTransaction,
    TimeLineTransaction,
  },
  data() {
    return {
      renderPage: false,
      showProgressBar: true,
      data: {
        link: {},
        payment: {},
        product: {},
        customer: {},
        user: {},
      },
      address: {},
    }
  },
  beforeRouteLeave(to, from, next) {
    this.renderPage = false
    next()
  },
  async mounted() {
    callLoading(true)
    await this.handleGetData()
    this.handleCheckScreenSize()
    window.addEventListener('resize', this.handleCheckScreenSize)
    callLoading(false)
    this.renderPage = true
  },
  methods: {
    async handleGetData() {
      try {
        const hash = window.location.pathname.split('/')[4]
        const { status, data } = await getTransaction(hash)

        if (status !== 200) {
          this.$router.push('/error404')
          return
        }
        const { address, ...dataWithoutAddress } = data
        this.address = address
        const date = new Date(dataWithoutAddress.payment.transaction_date)
        date.setHours(date.getHours() + 3)
        dataWithoutAddress.payment.transaction_date = date.toISOString()
        this.data = dataWithoutAddress
        this.link = `${process.env.VUE_APP_URL}link-pagamento/1/${hash}`
      } catch {
        this.$router.push('/error404')
      }
    },
    handleCheckScreenSize() {
      if (window.innerWidth > 1200) {
        this.showProgressBar = true
      } else {
        this.showProgressBar = false
      }
    },
  },
}
</script>
